import _useOnMount from "./useOnMount";
import _useOnDismount from "./useOnDismount";
// import _useOptionalStateManager from "./useOptionalStateManager"
import _useOnFairGoMessage from "./useOnFairGoMessage";
import _useIsFirstRender from "./useIsFirstRender";
import _useIsFullyVisible from "./useIsFullyVisible";
// import _useIsPortrait from "./useIsPortrait";
// import _useSetDefaultValue from "./useSetDefaultValue";
import _usePendingPrefill from "./usePendingPrefill";
import _useFocusState from "./useFocusState";
import _useMissingAccountExternalIdRedirect from "./useMissingAccountExternalIdRedirect";
import _useTimedToggle from "./useTimedToggle";
import _useLoanRouteController from "./useLoanRouteController";
import _useAccountExternalId from "./useAccountExternalId";
import _useRequestedProductType from "./useRequestedProductType";

export const useOnMount = _useOnMount;
export const useOnDismount = _useOnDismount;
// export const useOptionalStateManager = _useOptionalStateManager;
export const useOnFairGoMessage = _useOnFairGoMessage;
export const useIsFirstRender = _useIsFirstRender;
export const useIsFullyVisible = _useIsFullyVisible;
// export const useIsPortrait = _useIsPortrait;
// export const useSetDefaultValue = _useSetDefaultValue;
export const usePendingPrefill = _usePendingPrefill;
export const useFocusState = _useFocusState;
export const useMissingAccountExternalIdRedirect = _useMissingAccountExternalIdRedirect;
export const useTimedToggle = _useTimedToggle;
export const useLoanRouteController = _useLoanRouteController;
export const useAccountExternalId = _useAccountExternalId;
export const useRequestedProductType = _useRequestedProductType;

export * from "./useLoanRouteController";
export * from "./useOptionalStateManager"
export * from "./useOnMount";
export * from "./useSetDefaultValue";
export * from  "./useIsPortrait";